import BaseModule from "./base-module";

class Common extends BaseModule {
  // 获取注关于我们
  aboutUs(payload) {
    return this.post("/api/article/getAboutUs", payload);
  }

  // 首页推荐分类及商品
  recommend(payload) {
    return this.post("/api/index/recommend", payload);
  }

  // 新增留言
  feedbackAdd(payload) {
    return this.post("/api/feedback/add", payload);
  }

  // 店铺资料获取
  loadShopInfo(payload) {
    return this.post("api/shop/get", payload);
  }

  // 首页广告图片
  loadIndexAd(payload) {
    return this.post("/api/ad/getForPc", payload);
  }

  // 获取文章详情
  loadArticleDetail(payload) {
    return this.post("/api/article/get", payload);
  }
}

export default new Common();
